import type { HistoryPrediction, HistoryResultPayload } from '../types/history'

export const resolveHistoryDisplayPredictions = (
    result: HistoryResultPayload | null | undefined,
    preferRaw: boolean
): HistoryPrediction[] => {
    if (preferRaw && Array.isArray(result?.raw_predictions)) {
        return result.raw_predictions
    }

    return Array.isArray(result?.predictions) ? result.predictions : []
}
